/* eslint-disable consistent-return */
import fetch from 'isomorphic-unfetch';
import config from '../../config';

export const FETCH_TOP_RANKED_MEN = 'TOP_RANKED:FETCH_MEN';
export const FETCH_TOP_RANKED_MEN_SUCCESS = 'TOP_RANKED:FETCH_MEN_SUCCESS';
export const FETCH_TOP_RANKED_MEN_FAILURE = 'TOP_RANKED:FETCH_MEN_FAILURE';
export const FETCH_TOP_RANKED_WOMEN = 'TOP_RANKED:FETCH_WOMEN';
export const FETCH_TOP_RANKED_WOMEN_SUCCESS = 'TOP_RANKED:FETCH_WOMEN_SUCCESS';
export const FETCH_TOP_RANKED_WOMEN_FAILURE = 'TOP_RANKED:FETCH_WOMEN_FAILURE';
export const FETCH_TOP_RANKED = 'TOP_RANKED:FETCH';
export const FETCH_TOP_RANKED_SUCCESS = 'TOP_RANKED:FETCH_SUCCESS';

const { apiHost, appHost } = config;

export const fetchTopMen = (count) => async (dispatch) => {
    dispatch({ type: FETCH_TOP_RANKED_MEN });
    try {
        const res = await fetch(`${apiHost}/v2/player/top?gender=M&count=${count}`);

        const data = await res.data;
        if (data.error) {
            dispatch({ type: FETCH_TOP_RANKED_MEN_FAILURE, data: data.error });
        } else {
            dispatch({ type: FETCH_TOP_RANKED_MEN_SUCCESS, data });
        }
    } catch (error) {
        dispatch({ type: FETCH_TOP_RANKED_MEN_FAILURE });
    }
};

export const fetchTopWomen = (count) => async (dispatch) => {
    dispatch({ type: FETCH_TOP_RANKED_WOMEN });
    try {
        const res = await fetch(`${apiHost}/v2/player/top?gender=F&count=${count}`);
        const { data } = res;
        if (data.error) {
            dispatch({ type: FETCH_TOP_RANKED_WOMEN_FAILURE, data: data.error });
        } else {
            dispatch({ type: FETCH_TOP_RANKED_WOMEN_SUCCESS, data });
        }
    } catch (error) {
        dispatch({ type: FETCH_TOP_RANKED_WOMEN_FAILURE });
    }
};

export const fetchTopMenByTags = (tags, template, count) => async (dispatch) => {
    dispatch({ type: FETCH_TOP_RANKED_MEN });
    try {
        return await fetch(`${apiHost}/v2/player/top?gender=M${tags ? `&tags=${tags}` : ''}${template ? `&template=${template}` : ''}${count && count > 0 ? `&count=${count}` : ''}`)
            .then(res => res.json())
            .then(data => {
                if (data.error) {
                    dispatch({ type: FETCH_TOP_RANKED_MEN_FAILURE, data: data.error });
                } else {
                    dispatch({ type: FETCH_TOP_RANKED_MEN_SUCCESS, data });
                }
            });
    } catch (error) {
        dispatch({ type: FETCH_TOP_RANKED_MEN_FAILURE });
    }
};

export const fetchTopWomenByTags = (tags, template, count) => async (dispatch) => {
    dispatch({ type: FETCH_TOP_RANKED_WOMEN });
    try {
        return await fetch(`${apiHost}/v2/player/top?gender=F${tags ? `&tags=${tags}` : ''}${template ? `&template=${template}` : ''}${count && count > 0 ? `&count=${count}` : ''}`)
            .then(res => res.json())
            .then(data => {
                if (data.error) {
                    dispatch({ type: FETCH_TOP_RANKED_WOMEN_FAILURE, data: data.error });
                } else {
                    dispatch({ type: FETCH_TOP_RANKED_WOMEN_SUCCESS, data });
                }
            });
    } catch (error) {
        dispatch({ type: FETCH_TOP_RANKED_WOMEN_FAILURE });
    }
};

export const fetchRankingsData = ({ tags, template, count, skip }) => async (dispatch) => {
    dispatch({ type: FETCH_TOP_RANKED });

    const mensResults = await fetch(`${apiHost}/v3/player/top?gender=M${tags ? `&tags=${tags}` : ''}${template ? `&template=${template}` : ''}${count && count > 0 ? `&count=${count}` : ''}${skip ? `&skip=${skip}` : ''}`);
    const mensResultsJson = await mensResults.json();

    const womensResults = await fetch(`${apiHost}/v3/player/top?gender=F${tags ? `&tags=${tags}` : ''}${template ? `&template=${template}` : ''}${count && count > 0 ? `&count=${count}` : ''}${skip ? `&skip=${skip}` : ''}`);
    const womensResultsJson = await womensResults.json();

    const payload = {
        men: {
            error: (mensResultsJson.error || null),
            players: (!mensResultsJson.error ? mensResultsJson : []),
        },
        women: {
            error: (womensResultsJson.error || null),
            players: (!womensResultsJson.error ? womensResultsJson : []),
        },
    };
    dispatch({
        type: FETCH_TOP_RANKED_SUCCESS,
        payload,
    });
};

export const handleShowAllRedirect = ({ gender, level, subLevel = '' }) => async () => {
    const levelDictionary = {
        U14: 5,
        U16: 4,
        U18: 1,
        HIGHSCHOOL: 6,
        COLLEGE: 2,
        PRO: 3,
    };

    window.location = `${appHost}/login?next=/top-players?tab=${gender === 'm' ? '1' : '2'}&level=${levelDictionary[level]}&sublevel=${subLevel}`;
};
